<template>
  <section class="detail">
    <h3 class="detail-h3-title">中国科学院老年人大学校规</h3>
    <div class="detail-title">{{articleInfo.title}}</div>
    <div v-html="articleInfo.content"  class="detail-desc detail-margin detail-img"></div>
    <div class="ant-button">
      <a-button type="primary" class="works-filter-button" @click="Btntoschoolrule">
        返回
      </a-button>
    </div>
  </section>
</template>
<script>
export default {
  components: {},
  data () {
    return {
      loading: true,
      articleInfo: {},
      sourceBaseUrl: '',
    }
  },
  mounted () {
    this.sourceBaseUrl = this.$root.sourceBaseUrl;
    this.getInfo();
  },
  methods: {
        getInfo () {
          var url = this.$root.apiBaseUrl + '?g=api&m=api2&a=get_school_alonerules&id=' + this.$route.params.id;
          this.loading = true;
          this.$http.get(url).then(function (response) {
            if (response.body.status == 1) {
              this.articleInfo = response.body.data;
            }
            this.loading = false;
          }, function (reserror) {
            console.log(reserror);
          })
        },
        Btntoschoolrule(){
          this.$router.push('/main/schoolrules')
        }
  }
}
</script>
<style lang="less" scoped>
.detail{
  flex-grow: 1;
  overflow: hidden;
  &-h3-title{
    margin: 48px 0 25px;
    height:26px;
    line-height: 26px;
    font-size:25px;
    font-weight:400;
    color:rgba(0,77,153,1);
    text-align: center;
  }
  &-title{
    margin-top: 9px;
    margin-bottom: 12px;
    height:22px;
    line-height: 22px;
    font-size:22px;
    font-weight:400;
    color:rgba(0,0,0,1);
    text-align: center;
  }
  &-audio{
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 auto;
    height: 38px;
    width: max-content;
    margin-bottom: 20px;
    &::after, &::before{
      position: absolute;
      content: '';
      left: -340px;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      height: 1px;
      width: 320px;
      background: #D1D1D1;
    }
    &::before{
      left: auto;
      right: -340px;
    }
    &-image{
      width: 64px;
      height: 38px;
    }
    &-date{
      margin-left: 10px;
      font-size:12px;
      font-weight:400;
      color:rgba(0,0,0,1);
    }
  }
  &-image{
    display: block;
    margin: 30px auto 40px;
    max-width: 90%;
    // height: 344px;
    border: 6px solid #fff;
    box-shadow: 0px 0px 14px 0px rgba(6, 0, 1, 0.4);
    background: #f1f1f1;
    border-radius: 8px;
    box-sizing: content-box;
  }
  &-desc{
    font-size:16px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:30px;
    text-align: justify;
  }
  &-margin{
    margin-bottom: 40px;
  }
}
.ant-btn{
    //display: flex;
    margin:15px auto;
    //align-items: center;
    width:116px;
    height:38px;
    //border-radius:4px;
}
.ant-button{
  display: flex;
  justify-content: center;
  align-items: center;
  width:100%;
}
.box{
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 auto 90px;
  width:334px;
  height:27px;
  background:rgba(242,242,242,1);
  border-radius:4px;
  &-item{
    display: flex;
    align-items: center;
    &-image{
      width: 17px;
      height: 17px;
    }
    &-txt{
      margin-left: 8px;
      font-size:12px;
      font-weight:400;
      color:rgba(0,0,0,1);
    }
  }
}
</style>
